import React from "react";
import { connect } from "react-redux";
import { array } from "prop-types";
import _ from "lodash";

class Restricted extends React.Component {
  render() {
    const { currentProfile } = this.props;
    let hasRejectedList = this.props.hasOwnProperty("rejected");
    let hasAcceptedList = this.props.hasOwnProperty("accepted");
    let canShow = false;

    if (hasRejectedList) {
      const rejectedList = this.props.rejected;
      canShow = !_.includes(rejectedList, currentProfile);
    } else if (hasAcceptedList) {
      const acceptedList = this.props.accepted;
      canShow = _.includes(acceptedList, currentProfile);
    }

    if (canShow) {
      return this.props.children;
    }

    return null;
  }
}

Restricted.propTypes = {
  accepted: array,
  rejected: array
};

const mapStateToProps = state => ({
  accountName: state.app.activeAccount.name,
  currentProfile: state.app.user.profile
});

export default connect(mapStateToProps, null)(Restricted);



// WEBPACK FOOTER //
// ./src/components/Restricted.js